export default __webpack_public_path__ + "static/media/close_hover_white.75945d20.svg";